<div class="auth-page">
  <div class="auth-background-gradient"></div>
  
  <div class="auth-container">
    <div class="auth-card">
      <!-- Logo Section -->
      <div class="auth-logo-section">
        <div class="auth-logo">
          <img
            #logoImg
            src="assets/images/logo.svg"
            alt="Rewaa Logo"
            class="logo-image"
            loading="lazy"
          />
        </div>
      </div>

      <!-- Content Section -->
      <div class="auth-content">
        <div class="auth-header">
          <h3 class="auth-title">{{ 'login.title' | translate }}</h3>
          <p class="auth-subtitle">Manage platform with ease and confidence</p>
        </div>

        <!-- Sign In Button -->
        <div class="auth-button-section">
          <p-button
            (click)="signIn()"
            [label]="'login.sign_in' | translate"
            [loading]="false"
            icon="pi pi-sign-in"
            [styleClass]="'auth-sign-in-button'"
          ></p-button>
          <p class="auth-helper-text">
            Sign in with your Google account to get started
          </p>
        </div>
      </div>

      <!-- Footer Section -->
      <div class="auth-footer">
        <div class="auth-features">
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span class="feature-text">Secure</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span class="feature-text">Fast</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span class="feature-text">Reliable</span>
          </div>
        </div>
        <div class="auth-copyright">
          <p>&copy; {{ currentYear }} Rewaa Technology.</p>
        </div>
      </div>
    </div>
  </div>
</div>
